export default __webpack_public_path__ + "static/media/siediti.0aa48d7f.svg";